<template>
  <div>
    <vs-prompt
      id="div-with-loading1"
      class="vs-con-loading__container1"
      title="Student"
      @cancel="close"
      @accept="accept"
      @close="close"
      :active.sync="promptStatusForm"
      :is-valid="validInput"
    >
      <div class="con-exemple-prompt">
        <vs-input
          placeholder="Password"
          vs-placeholder="Password"
          v-model="dataObject.password"
          class="mt-3 w-full"
        />
        <vs-input
          placeholder="Confirm Password"
          vs-placeholder="Confirm Password"
          v-model="dataObject.c_password"
          class="mt-3 w-full"
        />

        <vs-alert
          :active="!validInput"
          color="danger"
          vs-icon="new_releases"
          class="mt-4"
        >
          Please fill all fields to complete
        </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  props: {
    promptStatus: {
      required: true,
      type: Boolean
    },
    oldDataObject: {
      required: true,
      type: Object
    }
  },
  components: {
    vSelect
  },
  data() {
    return {
      status: false,
      dataObject: {
        id: -1,
        password: "",
        c_password: ""
      },
      promptStatusForm: false
    };
  },
  mounted() {
    this.dataObject = this.oldDataObject;
  },
  computed: {
    validInput() {
      return true;
    }
  },
  methods: {
    reset() {
      this.dataObject.password = "";
      this.dataObject.c_password = "";
    },
    accept() {
      if (this.dataObject.id == -1) this.store();
      else this.edit();
    },
    close() {
      this.promptStatusForm = false;
      this.$emit("close", false);
      this.reset();
    },
    async store() {
      this.promptStatusForm = true;
      this.$vs.loading();

      await axios
        .post("/city", this.dataObject)
        .then(response => {
          this.promptStatusForm = false;
          this.$vs.loading.close();
          if (response.status === 200) {
            this.$emit("updateStatus", {
              isNew: true,
              data: response.data.data
            });
            this.$vs.notify({
              title: "Added Successful",
              text: "Your record added Successfuly",
              color: "success",
              position: "top-left"
            });
            this.reset();
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: response.data.message,
              color: "danger",
              position: "top-left"
            });
          }
        })
        .catch(err => {
          this.$vs.notify({
            title: "Error",
            text: "You have entered duplicate information",
            color: "danger",
            position: "top-left"
          });
          this.$vs.loading.close();
        });
      this.$vs.loading.close();
    },
    edit() {
      this.promptStatusForm = true;
      this.$vs.loading();

      axios
        .put("/dashboard/student/" + this.dataObject.id, this.dataObject)
        .then(response => {
          this.promptStatusForm = false;
          this.$vs.loading.close();
          if (response.status === 200) {
            this.$emit("updateStatus", {
              isNew: false,
              data: response.data.data
            });
            this.$vs.notify({
              title: "Update Successful",
              text: "Your record updated Successfuly",
              color: "success",
              position: "top-left"
            });
            this.reset();
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: response.data.message,
              color: "danger",
              position: "top-left"
            });
          }
        })
        .catch(err => {
          this.$vs.notify({
            title: "Error",
            text: "You have entered duplicate information",
            color: "danger",
            position: "top-left"
          });
          this.$vs.loading.close();
        });
    }
  },
  watch: {
    promptStatus: function() {
      this.dataObject = this.oldDataObject;
      this.promptStatusForm = this.promptStatus;
    },
    oldDataObject: function() {
      this.dataObject = this.oldDataObject;
    }
  }
};
</script>
